<mat-form-field [formGroup]="group" class="input" appearance="outline">
  <mat-label>{{ config.label }}</mat-label>
  <input #input class="decimal" *ngIf="config.selectAll" onfocus="this.select()" currencyMask matInput [formControlName]="config.name"
  (focus)="keyboardService.onInputFocus(keyboardChange, $event)"
  (ngModelChange)="keyboardService.onInputChange(group.getRawValue(), input)"
  />
  <input #input class="decimal" *ngIf="!config.selectAll" currencyMask matInput [formControlName]="config.name"
  (focus)="keyboardService.onInputFocus(keyboardChange, $event)"
  (ngModelChange)="keyboardService.onInputChange(group.getRawValue(), input)"
  (blur)="onBlur.emit($event)"
  />
  <!-- <mat-error *ngIf="group.get(config.name)?.touched && group.get(config.name)?.hasError('required')">
    <span>Campo Obrigatório</span>
  </mat-error> -->
</mat-form-field>
